export default () => ({
  campaigns: [],
})
